import { StrictMode } from 'react'
import { createRoot, hydrateRoot } from 'react-dom/client'
import './index.css'
import './i18n'
import './webmcp'
import App from './App.tsx'
import { initializeAnalytics } from './analytics.ts'
import { pathWithoutLocale } from './i18n.ts'

if (!/^\/(?:app|admin)(?:\/|$)/.test(window.location.pathname)) initializeAnalytics()

document.documentElement.dataset.js = 'true'

const root = document.getElementById('root')!
const app = (
  <StrictMode>
    <App />
  </StrictMode>
)

const currentPath = window.location.pathname.replace(/\/+$/, '') || '/'
const currentRoute = pathWithoutLocale(currentPath).replace(/\/+$/, '') || '/'
const clientOnlyRoute = currentPath === '/app'
  || currentPath.startsWith('/app/')
  || currentPath === '/admin'
  || currentPath.startsWith('/admin/')
  || currentPath === '/design'
  || /^\/articles\/[^/]+$/.test(currentRoute)

if (root.hasChildNodes() && !clientOnlyRoute) hydrateRoot(root, app)
else {
  if (clientOnlyRoute) root.replaceChildren()
  createRoot(root).render(app)
}
